import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 10L16.8367 12.8319L17.0711 17.0711L12.8319 16.8367L10 20L7.16814 16.8367L2.92893 17.0711L3.16329 12.8319L-4.37114e-07 10L3.16329 7.16814L2.92893 2.92893L7.16814 3.16329L10 -4.37114e-07L12.8319 3.16329L17.0711 2.92893L16.8367 7.16814L20 10Z"
      fill="#308FFF"
    />
    <g clipPath="url(#clip0_558_21232)">
      <path
        d="M9.99996 10.8334V14.1668H6.66663C6.66663 13.2827 7.01782 12.4348 7.64294 11.8097C8.26806 11.1846 9.11591 10.8334 9.99996 10.8334V10.8334ZM9.99996 10.4167C8.61871 10.4167 7.49996 9.298 7.49996 7.91675C7.49996 6.5355 8.61871 5.41675 9.99996 5.41675C11.3812 5.41675 12.5 6.5355 12.5 7.91675C12.5 9.298 11.3812 10.4167 9.99996 10.4167ZM11.0812 12.8384C11.0284 12.6161 11.0284 12.3845 11.0812 12.1622L10.6679 11.9234L11.0845 11.2017L11.4979 11.4405C11.6638 11.2834 11.8643 11.1675 12.0833 11.1022V10.6251H12.9166V11.1022C13.1383 11.168 13.3383 11.2855 13.502 11.4405L13.9154 11.2017L14.332 11.9234L13.9187 12.1622C13.9715 12.3844 13.9715 12.6158 13.9187 12.838L14.332 13.0768L13.9154 13.7984L13.502 13.5597C13.3361 13.7168 13.1356 13.8327 12.9166 13.898V14.3751H12.0833V13.898C11.8643 13.8327 11.6638 13.7168 11.4979 13.5597L11.0845 13.7984L10.6679 13.0768L11.0812 12.8384V12.8384ZM12.5 12.0834C12.3895 12.0834 12.2835 12.1273 12.2053 12.2055C12.1272 12.2836 12.0833 12.3896 12.0833 12.5001C12.0833 12.6106 12.1272 12.7166 12.2053 12.7947C12.2835 12.8729 12.3895 12.9168 12.5 12.9168C12.6105 12.9168 12.7164 12.8729 12.7946 12.7947C12.8727 12.7166 12.9166 12.6106 12.9166 12.5001C12.9166 12.3896 12.8727 12.2836 12.7946 12.2055C12.7164 12.1273 12.6105 12.0834 12.5 12.0834Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_558_21232">
        <rect width={10} height={10} fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
